import { tt } from '@agos/shared'

/**
 * What the handover's *Celková tržba* is actually counting - §9.449, FB-771.
 *
 * **The owner compared it with a register's closing slip and the two differed by 111,05.** Neither
 * figure was wrong: `HandoverReconciliation.totalsFor` scopes by **one employee**, excludes every
 * order on a **tab**, and filters by neither channel nor register, while a *záverečka* sums what was
 * rung up **on the device**, whoever rang it. Two people on one register and the device total
 * exceeds either handover by the other person's share - measured at 105,00 on a real restaurant day.
 *
 * **So the money was right and the screen was silent.** `Celková tržba` says *total takings* and
 * nothing said whose. These three sentences are what the screen was missing, and all three are
 * load-bearing: each one alone still leaves the comparison looking reasonable.
 */

/** Whose takings these are - the first thing a person comparing two slips needs to know. */
export function handoverScopeNote(): string {
  return tt('Toto sú tvoje dnešné tržby, nie tržby celej pokladne.')
}

/**
 * Why a tab is not in the figure.
 *
 * §10A.1's reasoning, made visible to the person it affects: while a tab is open the money has not
 * been collected, and once it is settled the settlement carries it - so counting the order too would
 * count it twice.
 */
export function handoverTabNote(): string {
  return tt('Objednávky na účte sa tu nepočítajú - prenesie ich až vyúčtovanie účtu.')
}

/**
 * That a register's closing slip is a different total, said plainly.
 *
 * **This is the sentence FB-771 exists for.** Refusing to mention the comparison is what produced
 * the report; naming it is what stops the next one.
 */
export function handoverRegisterNote(): string {
  return tt('Záverečka v pokladni počíta celú kasu, takže jej súčet bude iný.')
}
